<template>
  <div id="app" :class="{ 'desktop-mode': isDesktop }">
    <!-- 桌面客户端无边框窗口: 顶部拖拽条用于拖动窗口(右上角Win窗口按钮/左上角mac交通灯为系统层, 不受遮挡) -->
    <div v-if="isDesktop" class="desktop-drag-bar" :class="{ 'drag-bar-login': isLogin }"></div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  components: {},
  data() {
    return {
      verTimer: null,
      // Electron preload 注入标识: 桌面客户端内渲染拖拽条并下移内容
      isDesktop: !!window.__BOXIM_DESKTOP__
    }
  },
  computed: {
    // 登录页拖拽条用登录页渐变底色, 避免顶部白条割裂
    isLogin() {
      return this.$route.path === '/login';
    }
  },
  methods: {
    // 版本检测：定时拉取 version.json(构建时生成)与当前加载版本比对。
    // 2026-08-03 决策: 不弹窗(强制弹窗打断聊天体验差)，发现新版本通过 eventBus
    // 通知 Home 在左侧头像上亮红点，用户点击红点才刷新加载新版。
    checkVersion() {
      const cur = process.env.VUE_APP_BUILD_VERSION;
      if (!cur) {
        return;
      }
      fetch((process.env.BASE_URL || '/') + 'version.json?t=' + Date.now(), { cache: 'no-store' })
        .then((r) => r.json())
        .then((d) => {
          if (!d || !d.version || d.version === cur) {
            // 已是最新版: 清掉过期的"待更新"标记。
            // 否则连续发版场景下(旧页检测到新版A→刷新时实际已发更新的B),
            // sessionStorage 残留的 A 会让 Home 的 nv!==cur 判断永远亮红点, 刷新也不灭
            if (sessionStorage.getItem('imNewVersion')) {
              sessionStorage.removeItem('imNewVersion');
            }
            return;
          }
          // 同一版本只通知一次(sessionStorage 跨刷新保留, Home 加载时也会读)
          if (sessionStorage.getItem('imNewVersion') === d.version) {
            return;
          }
          sessionStorage.setItem('imNewVersion', d.version);
          this.$eventBus.$emit('new-version', d.version);
        }).catch(() => { });
    }
  },
  created() {
    // 启动时应用已保存的黑夜模式（登录页也生效）
    if (localStorage.getItem('darkMode') === 'true') {
      document.documentElement.classList.add('theme-dark');
    }
  },
  mounted() {
    // 每 60 秒检测一次新版本
    this.verTimer = setInterval(this.checkVersion, 60000);
  },
  beforeDestroy() {
    if (this.verTimer) {
      clearInterval(this.verTimer);
      this.verTimer = null;
    }
  }
}
</script>

<style lang="scss">
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  position: absolute;
  height: 100%;
  width: 100%;
  color: var(--im-text-color);
  font-family: var(--im-font-family);
}

// 桌面客户端: 内容整体下移36px让出拖拽条
#app.desktop-mode {
  padding-top: 36px;
  box-sizing: border-box;
}

// 桌面客户端窗口拖拽条(仅承担拖动, 底色随页面主题)
.desktop-drag-bar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 36px;
  z-index: 3000;
  -webkit-app-region: drag;
  background: var(--im-bg-color, #fff);
}

// 登录页: 与登录背景渐变同色, 视觉无缝
.desktop-drag-bar.drag-bar-login {
  background: linear-gradient(135deg, #d4e2f8 0%, #dce8fa 60%);
}
</style>
